module.exports = __webpack_public_path__ + "static/media/slider-img.fd7da5cb.png";